import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class PrivilegeService extends RestfulService<Models.Privilege> {

  constructor(private restService: RestService) {
    super(Models.Privilege);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('privileges');
  }

}
